import { LoadingButton, Rating, TextField } from "@helo/ui";
import { FormikValues, useFormik } from "formik";
import { httpsCallable } from "firebase/functions";
import { toast } from "react-hot-toast";

import { functions, CREATE_SHIPPING_EXP } from "~/config/firebase";

/**
 * Validator for Review form
 * @TODO : Use Yup Validation if robust validation solution is required.
 */
const validator = (values: FormikValues) => {
  const errors: any = {};

  if (!values.rating) {
    errors.rating = "Please select rating";
  }

  return errors;
};

interface ReviewFormProps {
  trackingNumber: string;
}

const ReviewForm = ({ trackingNumber }: ReviewFormProps) => {
  const createShippingExperience = httpsCallable(
    functions,
    CREATE_SHIPPING_EXP,
  );

  const formik = useFormik({
    initialValues: {
      rating: 0,
      comment: "",
    },
    validate: validator,
    onSubmit: async (values, helpers) => {
      const loader = toast.loading("We are processing your request...");
      helpers.setSubmitting(true);

      try {
        await createShippingExperience({
          trackingNumber,
          rating: values.rating,
          context: values.comment,
        });

        toast.success("Your review was submitted successfully!");
      } catch (e) {
        toast.error(
          "We could not process your request. Please try again later.",
        );
      } finally {
        helpers.setSubmitting(false);
        toast.dismiss(loader);
      }
    },
  });

  return (
    <form
      id="review-form"
      method="POST"
      name="reviewForm"
      onSubmit={formik.handleSubmit}
    >
      <div>
        <Rating
          id="rating"
          name="rating"
          size="large"
          value={
            formik.values.rating
              ? parseInt(formik.values.rating as string, 10)
              : 0
          }
          onChange={formik.handleChange}
        />
        {formik.touched.rating && Boolean(formik.errors.rating) ? (
          <p className="mb-1 text-danger text-xs font-normal">
            {formik.errors.rating}
          </p>
        ) : null}
      </div>
      <div className="mt-1">
        <TextField
          id="comment"
          name="comment"
          multiline
          rows={5}
          label="Add Your Comments"
          fullWidth
          value={formik.values.comment}
          onChange={formik.handleChange}
          error={formik.touched.comment && Boolean(formik.errors.comment)}
          helperText={formik.touched.comment && formik.errors.comment}
        />
      </div>
      <div className="mt-1/2">
        <LoadingButton
          variant="contained"
          size="large"
          type="submit"
          name="Submit"
          value="Submit"
          loading={formik.isSubmitting}
          sx={{ width: "100%" }}
        >
          Submit
        </LoadingButton>
      </div>
    </form>
  );
};

export default ReviewForm;
